export const formatErrorMessage = (msg: string | null) => {
  if (msg) {
    const a = msg.indexOf("Order Release Id:");
    const b = msg.indexOf("Errors:");
    return (
      msg.substring(0, a).toUpperCase() + "-- " + msg.substring(b, msg.length)
    );
  }
};
